import React from 'react';
import PropTypes from 'prop-types';

const ProductListing = props => {
  const showHeader = props.heading || props.lede || props.description;

  return (
    <div className="product-listing content-wrapper">
      {showHeader && (
        <div className="product-listing__header">
          {!!props.heading && (
            <h2 className="product-listing__header__heading subheading--small">
              {props.heading}
            </h2>
          )}

          {!!props.lede && (
            <h3 className="product-listing__header__lede natural-heading">
              {props.lede}
            </h3>
          )}

          {!!props.description && (
            <div
              className="product-listing__header__description text--body"
              dangerouslySetInnerHTML={{ __html: props.description }}
            />
          )}
        </div>
      )}

      <div className="product-listing__items">{props.children}</div>
    </div>
  );
};

ProductListing.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  lede: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default ProductListing;
